// This file is auto-generated by the "tsproxygen.exe" tool. Manual modification is not recommended.
import { makeServiceRequest } from '../ServiceRequest';
import type RequestOptions from '../RequestOptions';
import type SetMailboxJunkEmailConfigurationRequest from '../contract/SetMailboxJunkEmailConfigurationRequest';
import type OptionsResponseBase from '../contract/OptionsResponseBase';
import setMailboxJunkEmailConfigurationRequest from '../factory/setMailboxJunkEmailConfigurationRequest';

export default function setMailboxJunkEmailConfigurationOperation(
    req: SetMailboxJunkEmailConfigurationRequest,
    options?: RequestOptions
): Promise<OptionsResponseBase> {
    if (req !== undefined && !req['__type']) {
        req = setMailboxJunkEmailConfigurationRequest(req);
    }

    return makeServiceRequest<OptionsResponseBase>(
        'SetMailboxJunkEmailConfiguration',
        req,
        options
    );
}
